import { render } from "./KeyLogin.vue?vue&type=template&id=0c068fdb&scoped=true"
import script from "./KeyLogin.vue?vue&type=script&lang=js"
export * from "./KeyLogin.vue?vue&type=script&lang=js"

import "./KeyLogin.vue?vue&type=style&index=0&id=0c068fdb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c068fdb"]])

export default __exports__